import { Col } from '@wyz/ui';
import { Link } from 'react-router';
import { Trans } from '~/common/context';

const Footer = () => {
  return (
    <>
      <Col sm='auto'>
        <p className='mb-0 text-600' translate='no'>
          Copyright{' '}
          <span className='d-none d-sm-inline-block' translate='no'>
            |
          </span>
          <br className='d-sm-none' /> {new Date().getFullYear()} &copy;{' '}
          <a
            href='https://www.wyzgroup.com/en/'
            translate='no'
            target='_blank'
            rel='noreferrer'
          >
            WYZ
          </a>{' '}
          {' - '}
          <Link to={'legal-notices'}>
            <Trans i18nKey='app.common.legal_informations.legal_notices' />
          </Link>{' '}
          {' - '}
          <Link to={'terms-of-use'}>
            <Trans i18nKey='app.common.legal_informations.terms_of_use' />
          </Link>{' '}
          {' - '}
          <Link to={'use-of-cookies'}>
            <Trans i18nKey='app.common.legal_informations.use_of_cookies' />
          </Link>{' '}
          {' - '}
          <Link to={'confidentiality-agreements'}>
            <Trans i18nKey='app.common.legal_informations.confidentiality_agreements' />
          </Link>
        </p>
      </Col>
      <Col sm='auto'>
        <p className='mb-0 text-600' translate='no'>
          v2
        </p>
      </Col>
    </>
  );
};

export default Footer;
